import { render, staticRenderFns } from "./statistics-main-os.vue?vue&type=template&id=39f5af8a"
import script from "./statistics-main-os.vue?vue&type=script&lang=js"
export * from "./statistics-main-os.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports